import React, { useState } from 'react';
import s from './s.module.less';
import OnboardingStepContainer from '../OnboardingStepContainer';
import RadioOption from '../RadioOption';
import ActionButtons from '../ActionButtons';

interface PracticeSizeStepProps {
    onPracticeSizeChange?: (practiceSize: string) => void;
    onBack?: () => void;
    onNext?: () => void;
    onExit?: () => void;
    currentStep?: number;
    totalSteps?: number;
    initialPracticeSize?: string;
}

const practiceSizeOptions = [
    { id: 'just-me', label: 'Just me' },
    { id: '2-5-providers', label: '2–5 providers' },
    { id: '6-20-providers', label: '6–20 providers' },
    { id: '20-plus-providers', label: '20+ providers' },
];

export default function PracticeSizeStep({
    onPracticeSizeChange,
    onBack,
    onNext,
    onExit,
    currentStep = 4,
    totalSteps = 7,
    initialPracticeSize = '',
}: PracticeSizeStepProps) {
    const [selectedSize, setSelectedSize] = useState<string>(initialPracticeSize);

    const handleSizeChange = (sizeId: string) => {
        setSelectedSize(sizeId);

        if (onPracticeSizeChange) {
            onPracticeSizeChange(sizeId);
        }
    };

    return (
        <>
            <OnboardingStepContainer
                currentStep={currentStep}
                totalSteps={totalSteps}
                title="How many providers are in your practice?"
                subtitle="Choose the option that fits your practice size."
                showBackButton
                onBack={onBack}
            >
                <div className={s.optionsContainer}>
                    {practiceSizeOptions.map((option) => (
                        <RadioOption
                            key={option.id}
                            id={option.id}
                            label={option.label}
                            checked={selectedSize === option.id}
                            onChange={handleSizeChange}
                        />
                    ))}
                </div>
            </OnboardingStepContainer>

            <ActionButtons
                showBack
                showNext={false}
                currentStep={currentStep}
                onBack={onBack}
            />
        </>
    );
}
